import React from 'react';

const About = () => {
    return (
        <div className="container mx-auto px-6 py-12">
            <h1 className="text-4xl font-bold mb-6 text-gray-800">About Us</h1>
            <p className="text-lg text-gray-600 mb-4">
                Welcome to Taxberg. We are dedicated to providing the best tax and financial services to our clients.
            </p>
            <p className="text-lg text-gray-600">
                Our team of experts is here to assist you with all your business registration, GST compliance, and income tax filing needs.
            </p>
        </div>
    );
};

export default About;
